import React, { useState, useEffect } from 'react';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import AboutMe from './components/about/AboutMe';
import Work from './components/work/Work';
import Projects from './components/projects/Projects';
import Education from './components/education/education';
import CanvasAnimation from './components/animations/CanvasAnimation';
import MouseAnimation from './components/animations/MouseAnimation';
import TouchAnimation from './components/animations/TouchAnimation';
import WindowAnimation from './components/animations/WindowAnimation';
import ScrollToTop from './components/animations/ScrollToTop';
import ResumeRedirect from './components/ResumeRedirect';
import './GlobalStyles.css';

function App() {
  const [isDarkMode, setDarkMode] = useState(
    window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
  );

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    const handleSystemThemeChange = (e) => {
      setDarkMode(e.matches);
    };

    const matcher = window.matchMedia('(prefers-color-scheme: dark)');
    matcher.addListener(handleSystemThemeChange);

    if (isDarkMode) {
      document.body.setAttribute('data-theme', 'dark');
    } else {
      document.body.setAttribute('data-theme', 'light');
    }

    return () => {
      matcher.removeListener(handleSystemThemeChange);
    };
  }, [location, isDarkMode, navigate]);

  useEffect(() => {
    // Interactivity for background
    const interactive = document.querySelector('.interactive');
    let curX = 0;
    let curY = 0;
    let tgX = 0;
    let tgY = 0;
    let animationFrameId;

    const move = () => {
      curX += (tgX - curX) / 20;
      curY += (tgY - curY) / 20;
      if (interactive) {
        interactive.style.transform = `translate(${Math.round(curX)}px, ${Math.round(curY)}px)`;
      }
      animationFrameId = requestAnimationFrame(move);
    };

    const handleMouseMove = (event) => {
      tgX = event.clientX;
      tgY = event.clientY;
    };

    window.addEventListener('mousemove', handleMouseMove);
    move();

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <div className={isDarkMode ? 'dark-mode' : 'light-mode'}>
      {/* Background Mesh Gradient layer */}
      <div className="gradient-bg">
        <svg xmlns="http://www.w3.org/2000/svg">
          <defs>
            <filter id="goo">
              <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
              <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8" result="goo" />
              <feBlend in="SourceGraphic" in2="goo" />
            </filter>
          </defs>
        </svg>
        <div className="gradients-container">
          <div className="g1"></div>
          <div className="g2"></div>
          <div className="g3"></div>
          <div className="g4"></div>
          <div className="g5"></div>
          <div className="interactive"></div>
        </div>
      </div>

      <Header isDarkMode={isDarkMode} setDarkMode={setDarkMode} />
      <MouseAnimation isDarkMode={isDarkMode} />
      <TouchAnimation isDarkMode={isDarkMode} />
      <WindowAnimation isDarkMode={isDarkMode} />
      <Routes>
        <Route path="/" element={<><AboutMe isDarkMode={isDarkMode} /><CanvasAnimation isDarkMode={isDarkMode} /></>} />
        <Route path="/work" element={<><Work isDarkMode={isDarkMode} /></>} />
        <Route path="/projects" element={<><Projects isDarkMode={isDarkMode} /></>} />
        <Route path="/resume" element={<ResumeRedirect />} />
        <Route path="/education" element={<><Education isDarkMode={isDarkMode} /></>} />
      </Routes>
      <Footer isDarkMode={isDarkMode} setDarkMode={setDarkMode} />
      <ScrollToTop isDarkMode={isDarkMode} />
    </div>
  );
}

export default App;
